import React from "react";
import { formatApiError } from "../constants/apiErrorMessages";
import { FRONTEND_ORIGIN_URL_NO_SLASH } from "../config";
import withTracker from "./withtracker";
import AuthorizationHOC from "./AuthorizationHOC";
import { REGISTERED_USERS } from "../constants/userGroups";
import MetaData from "../components/meta/meta";
import SectionStart from "../components/sectionStart/sectionStart";
import {
  Sidebar,
  SidebarHeader,
  SideBar,
  SidebarLeft,
  SidebarRight,
} from "../components/layouts/layout1";
import Title from "../components/title/title";
import Heading from "../components/heading/heading";
import BracketButton from "../components/bracketButton/bracketButton";
import { getRouteUrl } from "../routers";
import {
  ROUTE_ORGANIZATION_EDIT,
  ROUTE_ORGANIZATION_VIEW_SINGLE,
} from "../routers/content/organization";
import OrganizationForm from "../components/organization/organizationForm/organizationForm";
import FaSpinner from "../components/faSpinner/faSpinner";
import ErrorMessage from "../components/errorMessage/errorMessage";
import Breadcrumb from "../components/breadcrumb/breadcrumb";
import withBreadCrumb from "./withBreadcrumb";
import UploadFileErrors from "../components/organization/uploadFileErrors/uploadFileErrors";
import { useParams } from "react-router-dom";
import useOrganizationEdit from "../customHooks/useOrganizationEdit";

const OrganizationEditHOC = (props) => {
  const { breadcrumb } = props;
  const { organizationId } = useParams();
  const {
    organizationData,
    loading,
    updateAnOrganization,
    fieldDocumentsIds,
    error,
  } = useOrganizationEdit();

  const onSubmit = (formData) => {
    updateAnOrganization.mutate({
      field_documents: fieldDocumentsIds,
      title: formData.title,
      description: formData.description,
    });
  };

  return (
    <div>
      <MetaData
        title="Edit Organization"
        url={
          FRONTEND_ORIGIN_URL_NO_SLASH +
          getRouteUrl(ROUTE_ORGANIZATION_EDIT, { organizationId })
        }
      />

      <SectionStart>
        <SideBar>
          <SidebarLeft>
            <SidebarHeader>
              <Title type="section" displayEffect>
                <Heading level="1">EDIT ORGANIZATION</Heading>
              </Title>
              {organizationData && (
                <div>
                  <Breadcrumb
                    {...breadcrumb}
                    params={{
                      org: {
                        href: getRouteUrl(ROUTE_ORGANIZATION_VIEW_SINGLE, {
                          organizationId,
                        }),
                        name: organizationData.title,
                      },
                    }}
                  />

                  <BracketButton
                    caretEnable
                    className="movingBrackets left"
                    title={"BACK TO OVERVIEW"}
                    url={getRouteUrl(ROUTE_ORGANIZATION_VIEW_SINGLE, {
                      organizationId: organizationData.uuid,
                    })}
                  />
                </div>
              )}
            </SidebarHeader>
          </SidebarLeft>
          <SidebarRight>
            <div>
              {error && (
                <ErrorMessage
                  message={
                    error.exception
                      ? formatApiError(error.exception)
                      : typeof error === "object"
                      ? error.message || JSON.stringify(error)
                      : error
                  }
                  style={{ marginBottom: 20 }}
                />
              )}

              {organizationData && (
                <div>
                  <OrganizationForm
                    initialValues={{
                      title: organizationData.title,
                      description: organizationData.description,
                      uuid: organizationData.uuid,
                    }}
                    onSubmit={onSubmit}
                    loading={loading}
                  />

                  <UploadFileErrors organizationId={organizationData.uuid} />
                </div>
              )}
              {loading && <FaSpinner loading />}
            </div>
          </SidebarRight>
        </SideBar>
      </SectionStart>
    </div>
  );
};

export default withTracker(
  AuthorizationHOC(REGISTERED_USERS)(
    withBreadCrumb(OrganizationEditHOC, {
      name: "Edit",
      parents: ["Organizations", "{org}"],
    })
  )
);
